export default __webpack_public_path__ + "static/media/etermax_brand-gamification_white.d6cdfe64.svg";